import { motion } from "framer-motion";
import { Handshake } from "lucide-react";

const PUB = process.env.PUBLIC_URL;

const partners = [
  {
    name: "Mum under Construction",
    tagline: "Pilates & Fitness Coach",
    logo: `${PUB}/partners/mum-under-construction.jpg`,
    href: "https://www.mumunderconstructionbarton.co.uk/about-us/",
  },
  {
    name: "Pivot 1st",
    tagline: "Class booking & management",
    logo: `${PUB}/partners/pivot1st.png`,
    href: "https://www.pivot1st.co.uk",
  },
  {
    name: "YAWN Life!",
    tagline: "Local family community",
    logo: `${PUB}/partners/yawn-life.png`,
    href: null,
  },
];

export default function Partners() {
  return (
    <section className="py-16 md:py-20" data-testid="partners-section">
      <div className="container mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-10">
          <span className="inline-flex items-center gap-2 text-sm text-[#14B8A6] tracking-[0.2em] uppercase font-bold">
            <Handshake size={16} /> Proud to partner with
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl font-bold tracking-tight text-[#0F172A] leading-tight">
            The friends who help us make a splash
          </h2>
          <p className="mt-4 text-lg text-[#334155]">
            We're lucky to work alongside brilliant local businesses and communities who share
            our passion for families, health and happiness.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6">
          {partners.map((p, i) => {
            const inner = (
              <>
                <div className="flex items-center justify-center h-24 mb-5">
                  <img
                    src={p.logo}
                    alt={`${p.name} logo`}
                    loading="lazy"
                    className="max-h-16 w-auto object-contain"
                  />
                </div>
                <p className="font-heading font-bold text-[#0F172A] leading-none">{p.name}</p>
                <p className="mt-1.5 text-sm text-[#64748B]">{p.tagline}</p>
              </>
            );
            const base =
              "block bg-white rounded-[2rem] p-8 border border-slate-100 shadow-sm text-center h-full transition-all duration-500";
            return (
              <motion.div
                key={p.name}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`partner-card-${i}`}
              >
                {p.href ? (
                  <a
                    href={p.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${base} hover:shadow-xl hover:-translate-y-1`}
                    data-testid={`partner-link-${i}`}
                  >
                    {inner}
                  </a>
                ) : (
                  <div className={base}>{inner}</div>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
